/**
 * ICF Guide actions - display ICF prompt list and fetch ICF article content
 */
import axios from 'axios';
import _isEmpty from 'lodash/isEmpty';
import _uniqBy from 'lodash/uniqBy';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';

import { getICFAccessdArticle } from './action-icf-page';
import UrlResources from '../constants/UrlResources';
import Page from '../../lib/page';
import { getNNAIcfId } from '../../lib/nnaHelper';
import { BNA } from '../../common/commonConstants';

const getBNAArticles = (recommendArticles) => Array.isArray(recommendArticles) && recommendArticles.filter((article) => article.channel === BNA);

/* --------------- Actions --------------- */
// Prepare fetching ICF content request
const requestICFContents = (url) => ({ type: types.REQUEST_ICF_CONTENTS, payload: url });

const requestICFArticleContents = (url) => ({ type: types.REQUEST_ARTICLE_ICF_CONTENTS, payload: url });

const receivedICFContents = (payload) => ({ type: types.RECEIVED_ICF_CONTENTS, payload });

const receivedICFArticleContents = (payload) => ({ type: types.RECEIVED_ARTICLE_ICF_CONTENTS, payload });

const receviedICFContentsError = () => ({ type: types.RECEIVED_ICF_CONTENTS_ERROR });

const receviedICFArticleContentsError = () => ({ type: types.RECEIVED_ARTICLE_ICF_CONTENTS_ERROR });

export const getIcfMappings = () => {
  try {
    const icfConfig = Page.getIcfConfig();
    return icfConfig.mapping;
  } catch (e) {
    return {};
  }
};

// Get ICF id from BNA-ICF mapping stored in the Remote config
const getICFList = (bnaArticles) => {
  const bnaMapping = getIcfMappings();

  const response = [];
  if (!Array.isArray(bnaArticles) || !bnaArticles.length || _isEmpty(bnaMapping)) {
    return response;
  }
  bnaArticles.forEach((article) => {
    const bnaId = (article.channelDetails || {}).bnaId;

    if (bnaMapping[bnaId]) {
      response.push(bnaMapping[bnaId]);
    }
  });
  return _uniqBy(response); // remove ICF duplications
};

// Formate URL with single/multiple ICF id
const getURL = (ICFList) => {
  if (!Array.isArray(ICFList) || !ICFList.length) {
    return '';
  }
  let baseUrl = '';
  ICFList.forEach((id) => {
    baseUrl += baseUrl ? `&icf_id=${id}` : `icf_id=${id}`;
  });
  return baseUrl;
};

// Using URL to fetch ICF contents
export const fetchGuideContents = (query) => (dispatch, getState) => {
  const pathName = _get(getState(), 'location.pathname');
  if (pathName && pathName.indexOf(UrlResources.HOME) !== -1) {
    // For Home Page
    dispatch(requestICFContents(query));

    return axios.get(`/smarthelp/interactive-guide?${query}`)
      .then((response) => {
        const icfData = response.data;
        const state = getState();
        let finalICFs = [];

        if (Array.isArray(icfData) && icfData.length > 0) {
          const isNNAEnabled = state.popular.isNetNewAccount;
          //  If NNA is enabled - Before storing the data if there is any BNA ICFID related to NNA hide it from showing in ICF List
          if (isNNAEnabled) {
            const nnaICFid = getNNAIcfId(); // Get NNA ICF id which is part of RC
            finalICFs = icfData.map((icfArticle) => ({ ...icfArticle, isHidden: (icfArticle.icf_id === nnaICFid) }));
          } else {
            // Default response.
            finalICFs = icfData.map((icfArticle) => ({ ...icfArticle, isHidden: false }));
          }
        }

        dispatch(receivedICFContents(finalICFs));
        // Getting the ICF Visited List
        dispatch(getICFAccessdArticle());
      })
      .catch(() => {
        dispatch(receviedICFContentsError());
      });
  }
  // For ICF Article Page
  dispatch(requestICFArticleContents(query));

  return axios.get(`/smarthelp/interactive-guide?${query}`)
    .then((response) => {
      dispatch(receivedICFArticleContents(response.data));
      // Getting the ICF Visited List
      dispatch(getICFAccessdArticle());
    })
    .catch(() => {
      dispatch(receviedICFArticleContentsError());
    });
};

export const fetchICFContents = ({ dispatch, recommendArticles, blacklistedMarketICFFlag }) => {
  if (typeof dispatch !== 'function' || !Array.isArray(recommendArticles)) {
    return null;
  }
  const bnaArticles = getBNAArticles(recommendArticles);

  if (Array.isArray(bnaArticles) && bnaArticles.length) {
    if (blacklistedMarketICFFlag) {
      return null;
    }
  } else {
    return null;
  }

  const ICFList = getICFList(bnaArticles);
  if (!Array.isArray(ICFList) || !ICFList.length) {
    return null;
  }

  const fetchingQuery = getURL(ICFList);

  return dispatch(fetchGuideContents(fetchingQuery));
};
